/**
 * riskReadModelPermissions.ts — Issue #400.
 *
 * Permission helpers for the risk-event read-model surface. Mirrors the backend
 * gate in apps/api/src/modules/risk-read-model/risk-read-model.controller.ts.
 *
 * Permission strings are `<resource>:<action>`; wildcards `*:*`,
 * `risk.read_model:*` and `*:<action>` resolve via the shared `hasPermission`
 * helper.
 */

import { hasPermission } from './crmPermissions';

export const RISK_READ_MODEL_PERMISSIONS = {
  READ: 'risk.read_model:read',
  READ_FULL: 'risk.read_model:read_full',
  GENERATE: 'risk.read_model:generate',
  REVIEW: 'risk.read_model:review',
  ARCHIVE: 'risk.read_model:archive',
  EXPORT: 'risk.read_model:export',
  REVEAL: 'risk.read_model:reveal',
  MANAGE: 'risk.read_model:manage',
} as const;

export function canSeeRiskReadModel(granted: readonly string[]): boolean {
  // Mirrors the backend list gate: caller needs both :read and :read_full to
  // see anything beyond an empty list. Without :read_full the page is useless
  // (detail / events / customer-rollups / export all 403), so we hide it.
  return (
    hasPermission(granted, RISK_READ_MODEL_PERMISSIONS.READ) &&
    hasPermission(granted, RISK_READ_MODEL_PERMISSIONS.READ_FULL)
  );
}

export function canGenerateRiskReadModel(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, RISK_READ_MODEL_PERMISSIONS.GENERATE);
}

export function canReviewRiskReadModel(granted: readonly string[]): boolean {
  return hasPermission(granted, RISK_READ_MODEL_PERMISSIONS.REVIEW);
}

export function canArchiveRiskReadModel(granted: readonly string[]): boolean {
  return hasPermission(granted, RISK_READ_MODEL_PERMISSIONS.ARCHIVE);
}

export function canExportRiskReadModel(granted: readonly string[]): boolean {
  return hasPermission(granted, RISK_READ_MODEL_PERMISSIONS.EXPORT);
}

export function canRevealRiskReadModel(granted: readonly string[]): boolean {
  return hasPermission(granted, RISK_READ_MODEL_PERMISSIONS.REVEAL);
}
